// path/to/store/payment-settings/payment-settings.actions.ts
import { createAction, props } from '@ngrx/store';

export interface IPaymentSettings {
  id?: number;
  feeSplitting: boolean;
  receivablesAdvance: boolean;
  issueCreditCardInvoice: boolean;
  issueDebitCardInvoice: boolean;
  issuePixInvoice: boolean;
  issueWireTransferInvoice: boolean;
  issueCashInvoice: boolean;
  chargeClientDebitCardFee: boolean;
  chargeClientCreditCardFee: boolean;
  installmentsWithoutFee: number;
}

export enum PaymentSettingsActionTypes {
  LOAD_PAYMENT_SETTINGS = '[Payment Settings] Load Payment Settings',
  LOAD_PAYMENT_SETTINGS_SUCCESS = '[Payment Settings] Load Payment Settings Success',
  LOAD_PAYMENT_SETTINGS_CURRENT = '[Payment Settings] Load Payment Settings Current',
  LOAD_PAYMENT_SETTINGS_CURRENT_SUCCESS = '[Payment Settings] Load Payment Settings Current Success',
  LOAD_PAYMENT_SETTINGS_FAILURE = '[Payment Settings] Load Payment Settings Failure',
  SAVE_PAYMENT_SETTINGS = '[Payment Settings] Save Payment Settings',
  SAVE_PAYMENT_SETTINGS_SUCCESS = '[Payment Settings] Save Payment Settings Success',
  SAVE_PAYMENT_SETTINGS_FAILURE = '[Payment Settings] Save Payment Settings Failure',
  UPDATE_PAYMENT_SETTINGS = '[Payment Settings] Update Payment Settings',
  UPDATE_PAYMENT_SETTINGS_SUCCESS = '[Payment Settings] Update Payment Settings Success',
  UPDATE_PAYMENT_SETTINGS_FAILURE = '[Payment Settings] Update Payment Settings Failure',
  DELETE_PAYMENT_SETTINGS = '[Payment Settings] Delete Payment Settings',
  DELETE_PAYMENT_SETTINGS_SUCCESS = '[Payment Settings] Delete Payment Settings Success',
  DELETE_PAYMENT_SETTINGS_FAILURE = '[Payment Settings] Delete Payment Settings Failure',
}

export const loadPaymentSettings = createAction(
  PaymentSettingsActionTypes.LOAD_PAYMENT_SETTINGS
);

export const loadPaymentSettingsSuccess = createAction(
  PaymentSettingsActionTypes.LOAD_PAYMENT_SETTINGS_SUCCESS,
  props<{ paymentSettings: IPaymentSettings[] }>()
);

export const loadPaymentSettingsCurrent = createAction(
  PaymentSettingsActionTypes.LOAD_PAYMENT_SETTINGS_CURRENT,
  props<{ id: any }>()
);

export const loadPaymentSettingsCurrentSuccess = createAction(
  PaymentSettingsActionTypes.LOAD_PAYMENT_SETTINGS_CURRENT_SUCCESS,
  props<{ paymentSettings: IPaymentSettings }>()
);

export const loadPaymentSettingsFailure = createAction(
  PaymentSettingsActionTypes.LOAD_PAYMENT_SETTINGS_FAILURE,
  props<{ error: any }>()
);

export const savePaymentSettings = createAction(
  PaymentSettingsActionTypes.SAVE_PAYMENT_SETTINGS,
  props<{ paymentSettings: IPaymentSettings }>()
);

export const savePaymentSettingsSuccess = createAction(
  PaymentSettingsActionTypes.SAVE_PAYMENT_SETTINGS_SUCCESS,
  props<{ paymentSettings: IPaymentSettings }>()
);

export const savePaymentSettingsFailure = createAction(
  PaymentSettingsActionTypes.SAVE_PAYMENT_SETTINGS_FAILURE,
  props<{ error: any }>()
);

export const updatePaymentSettings = createAction(
  PaymentSettingsActionTypes.UPDATE_PAYMENT_SETTINGS,
  props<{ paymentSettings: IPaymentSettings; id: number }>()
);

export const updatePaymentSettingsSuccess = createAction(
  PaymentSettingsActionTypes.UPDATE_PAYMENT_SETTINGS_SUCCESS,
  props<{ paymentSettings: IPaymentSettings }>()
);

export const updatePaymentSettingsFailure = createAction(
  PaymentSettingsActionTypes.UPDATE_PAYMENT_SETTINGS_FAILURE,
  props<{ error: any }>()
);

export const deletePaymentSettings = createAction(
  PaymentSettingsActionTypes.DELETE_PAYMENT_SETTINGS,
  props<{ id: number }>()
);

export const deletePaymentSettingsSuccess = createAction(
  PaymentSettingsActionTypes.DELETE_PAYMENT_SETTINGS_SUCCESS,
  props<{ id: number }>()
);

export const deletePaymentSettingsFailure = createAction(
  PaymentSettingsActionTypes.DELETE_PAYMENT_SETTINGS_FAILURE,
  props<{ error: any }>()
);
